import { fromPromise } from 'xstate';

import { inferDecisionMakers } from '#src/app/pages/startAPetitionV2/shared/api';

import type { OperationDeps } from '../types';

import { resolveDecisionMakersSkipReason } from './eligibility';
import type { Input, Output } from './types';

/**
 * The decision-maker inference operation: decides whether the input is eligible, tracks that decision
 * (`sap_dmi_eligibility`), then makes one `inferDecisionMakers` call. An ineligible input resolves
 * `null` without calling.
 */
export const createLogic = ({ utilityContext, track, featureConfigs }: OperationDeps) =>
	fromPromise<Output, Input>(async ({ input: { scope, ...apiInput } }) => {
		const skipReason = resolveDecisionMakersSkipReason(
			{ scope, location: apiInput.location },
			featureConfigs.sapDmiSupportedTargetCountries,
		);
		void track(
			'sap_dmi_eligibility',
			skipReason ? { dmi_fired: false, dmi_skip_reason: skipReason } : { dmi_fired: true },
		);
		if (skipReason) return null;

		return inferDecisionMakers(apiInput, { utilityContext, track });
	});
